module.exports = __webpack_public_path__ + "img/lianxi.d09e06d0.svg";